<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import Service from '../../../../domain/transferencia/services'
  import {prerequisitosLista} from '../../../../domain/grv/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import {forEach as _forEach, debounce} from 'lodash'
  import {Status, StatusTitle} from '../../../../domain/grv/helpers/GrvStatus'

  export default {
    components: {
      UPagination
    },
    nome: 'lista-tranferencias',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        isLoading: false,
        arrayData: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: '',
          dataSaida: null,
          dataChegada: null,
          categoria: null,
          patioOrigem: null,
          patioDestino: null,
          status: null
        },
        categorias: null,
        patios: null,
        prevent: {}
      }
    },
    computed: {
      noData () {
        if (this.arrayData === null) {
          return false
        }
        return this.arrayData.length === 0
      },
      Status () {
        return Status
      }
    },
    mounted () {
      prerequisitosLista()
        .then((response) => {
          this.categorias = response.data.categorias
          this.patios = response.data.patios
        })
        .catch((response) => {
          console.log(response)
        })
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    activated () {
    },
    destroyed () {
//      console.log('destruido')
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (id, status) {
        this.$router.push({name: 'transferencia-patio.visualizar', params: {id: id}})
      },

      loadData (limit, page, filtros) {
        this.arrayData = null
        this.isLoading = true
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.arrayData = response.data.arrayData
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.loadData(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) {
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.arrayData, key, Object.assign({}, this.arrayData[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          this.checkedAll = this.checkeds >= this.arrayData.length
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        for (let key in filtros) {
          if (filtros.hasOwnProperty(key)) {
            const val = filtros[key]
            if (val !== null) {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      reloadData () {
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },
      StatusTitle (s, t) {
        return StatusTitle(s, t)
      }
    },
    watch: {
      filtros: function (val) {
        console.log('Mudou')
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Transferências de Pátio <span class="badge">{{this.pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    Selecione uma transferência para modificar
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <router-link :to="{name: 'transferencia-patio.novo'}" tag="button" class="btn btn-default btn-sm ">
                      <i class="fa fa-plus"></i>
                      Nova transferência
                    </router-link>

                  </div>
                </div>
              </div>

              <!-- Importação aqui se necessário -->

            </div>

            <div class="wrapper-sm">
              <div class="panel panel-default wrapper-sm" id="filters_main">
                <div class="row m-l-xs m-r-xs" id="filters">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroDataChegada">Data da Saída</label>
                      <select id="filtroDataChegada" @change="reloadData" v-model="filtros.dataSaida" class="form-control">

                        <option :value="null">
                          Qualquer data
                        </option>

                        <option :value="'Hoje'">Hoje</option>
                        <option :value="'7dias'">Últimos 7 dias</option>
                        <option :value="'Mes'">Este mês</option>
                        <option :value="'Ano'">Este ano</option>

                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroDataSaida">Data da Chegada</label>
                      <select id="filtroDataSaida" @change="reloadData" v-model="filtros.dataChegada" class="form-control">

                        <option :value="null">
                          Qualquer data
                        </option>

                        <option :value="'Hoje'">Hoje</option>
                        <option :value="'7dias'">Últimos 7 dias</option>
                        <option :value="'Mes'">Este mês</option>
                        <option :value="'Ano'">Este ano</option>

                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroPatioOrigem">Patio de Origem</label>
                      <select id="filtroPatioOrigem" @change="reloadData" v-model="filtros.patioOrigem" class="form-control">

                        <option :value="null">
                          Todos
                        </option>

                        <option v-for="patio in patios" :value="patio.id">
                          {{patio.nome}}
                        </option>

                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroPatioDestino">Patio de Destino</label>
                      <select id="filtroPatioDestino" @change="reloadData" v-model="filtros.patioDestino" class="form-control">

                        <option :value="null">
                          Todos
                        </option>

                        <option v-for="patio in patios" :value="patio.id">
                          {{patio.nome}}
                        </option>

                      </select>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-9 m-b-xs">
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Iniciar Campanha de Marketing
                  </button>
                  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-sm btn-default" disabled data-toggle="dropdown">
                      Exportar
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                    </ul>
                  </div>
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Deletar
                  </button>
                </div>
                <div class="col-sm-3">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <div class="table-responsive" style="overflow-x: unset">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(arrayData)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th>GRV</th>
                    <th>Pátio de Origem</th>
                    <th>Pátio de Destino</th>
                    <th>Data de Saída</th>
                    <th>Data de Chegada</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <tr v-for="data in arrayData">
                    <td class="v-middle"><label
                      class="i-checks m-b-none"><input v-on:click.stop="lazyCheck(data)" type="checkbox" name="post[]"
                                                       v-model="data.selected"
                                                       tabindex="0" aria-checked="false"
                                                       aria-invalid="false"><i></i></label></td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">{{ data.grv.numero }}</td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      <a class="text-cap custom-link ">{{ data.patioOrigem.nome }}</a>
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.patioDestino.nome }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ moment(data.dataSaida.date).format('DD/MM/YYYY HH:mm') }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ moment(data.dataChegada.date).format('DD/MM/YYYY HH:mm') }}
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="noData">
                    <td colspan="9">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-4 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-4 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// ListaTransferencias.vue?6328415c